module.exports = __webpack_public_path__ + "static/media/izlozba (1).8e9080b5.jpg";